export default {
  meta: {
    title: '报表' // 机会点可以重命名，这里不适合写死
  }
};

